export const gameTitle = "Новогодний лабиринт";
export const startText =
  'Найдите выход из лабиринта за 2 минуты и получите <a href="new_year2024/Правила_участия_в_квесте.pdf" target="_blank">100 баллов</a>! Управляйте персонажем с помощью стрелок клавиатуры или путем перемещения по экрану мобильного устройства, чтобы добраться до выхода из лабиринта.';
